module.exports = __webpack_public_path__ + "img/Breast Milk.7653c624.png";